import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Divider,
	Form,
	Image,
	Modal
} from 'semantic-ui-react';

import { log } from '../../../services/utils';

import FormInput from '../../Form/FormInput';
import FormTextArea from '../../Form/FormTextArea';

const ProgramsModal = ( {
	closeModal,
	open,
	program
} ) => {
	return (
		<Modal open={ open }>
			<Modal.Header>Program Details</Modal.Header>
			<Modal.Content scrolling>
				{ log( 'programDetails' ) }
				<div className="responsive-contact-form-container">
					<div>
						<Image
							size="small"
							src="https://react.semantic-ui.com/images/wireframe/image.png"
						/>
					</div>
					{ program
						? <Form autoComplete="off">
							<Form.Group>
								<FormInput
									fieldLabel="Program Name"
									name="name"
									readOnly
									transparent
									value={ program.name }
									width={ 10 }
								/>
								<FormInput
									fieldLabel="Program Type"
									name="type"
									readOnly
									value={ program.type }
									width={ 6 }
								/>
							</Form.Group>

							<Divider
								hidden
								style={ { margin: '1.5rem 0' } }
							/>

							<Form.Group>
								<FormInput
									fieldLabel="Start Date"
									name="startDate"
									readOnly
									value={ new Date( program.startDate.replace( 'Z', '' ) ).toLocaleDateString() }
									width={ 5 }
								/>
								<FormInput
									fieldLabel="End Date"
									name="endDate"
									readOnly
									value={ new Date( program.endDate.replace( 'Z', '' ) ).toLocaleDateString() }
									width={ 5 }
								/>
								<FormInput
									fieldLabel="Program Status"
									name="submissionStatus"
									readOnly
									value={ program.submissionStatus }
									width={ 6 }
								/>
							</Form.Group>

							<Divider
								hidden
								style={ { margin: '1.5rem 0' } }
							/>

							<Form.Group>
								<FormTextArea
									fieldLabel="Description"
									name="description"
									readOnly
									value={ program.description }
									width={ 16 }
								/>
							</Form.Group>
						</Form>
						: null
					}
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button
					content="Close"
					onClick={ closeModal }
				/>
			</Modal.Actions>
		</Modal>
	);
};

ProgramsModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	open: PropTypes.bool,
	program: PropTypes.object
};

export default memo( ProgramsModal );
